/*****************************************************
Naam: dashboardHelpers.js
Locatie: src/components/Dashboard/utils/dashboardHelpers.js
Datum: 2026-02-07
Versie: 1.0.0
******************************************************
Beschrijving:
Utility functies voor het Dashboard component.
******************************************************/

export const formatTime = (date) => {
  return date.toLocaleTimeString('nl-NL', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: false 
  });
};

export const formatDate = (date) => {
  return date.toLocaleDateString('nl-NL', { 
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const convertDatum = (datum) => {
  if (!datum) return '';
  if (datum.match(/^\d{4}-\d{2}-\d{2}$/)) return datum;
  const parts = datum.split('-');
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return datum;
};

export const isDotVerlopen = (dotGeldig, dotPeriode) => {
  if (!dotPeriode || !dotGeldig) return false;
  
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  
  const startOfYear = new Date(now.getFullYear(), 0, 1);
  const days = Math.floor((now - startOfYear) / (24 * 60 * 60 * 1000));
  const currentWeek = Math.ceil((days + startOfYear.getDay() + 1) / 7);
  
  const parts = dotPeriode.split('-');
  if (parts.length !== 2) return false;
  
  const periodeNum = parseInt(parts[0]);
  const periodeYear = parseInt(parts[1]);
  
  if (isNaN(periodeNum) || isNaN(periodeYear)) return false;
  
  if (dotGeldig === 'maand') {
    if (periodeYear < currentYear) return true;
    if (periodeYear === currentYear && periodeNum < currentMonth) return true;
  } else if (dotGeldig === 'week') {
    if (periodeYear < currentYear) return true;
    if (periodeYear === currentYear && periodeNum < currentWeek) return true;
  }
  
  return false;
};

export const mapGoederen = (goederen) => {
  return goederen?.map(goed => ({
    aantal: goed.aantal || 1,
    soort: goed.soort || '',
    omschrijving: goed.omschrijving || '',
    stackable: goed.stackable || '',
    lengte: goed.lengte || '',
    breedte: goed.breedte || '',
    hoogte: goed.hoogte || '',
    gewicht: goed.gewicht || ''
  })) || [];
};

export const mapParsedToEmailData = (parsed, sourceType = 'email') => {
  const mappedGoederen = mapGoederen(parsed.goederen);
  
  return {
    klant: parsed.bedrijf || parsed.contactpersoon || '',
    contactpersoon: parsed.contactpersoon || '',
    laadLocatie: parsed.laadadres?.plaats || parsed.klant_plaats || '',
    laadPlaats: parsed.laadadres?.plaats || parsed.klant_plaats || '',
    laadAdres: parsed.laadadres?.adres || '',
    laadPostcode: parsed.laadadres?.postcode || '',
    laadLand: parsed.laadadres?.land || 'Nederland',
    laadDatum: convertDatum(parsed.laad_datum),
    laadBijzonderheden: parsed.bijzonderheden?.laden || parsed.bijzonderheden || '',
    losLocatie: parsed.losadres?.plaats || '',
    losPlaats: parsed.losadres?.plaats || '',
    losAdres: parsed.losadres?.adres || '',
    losPostcode: parsed.losadres?.postcode || '',
    losLand: parsed.losadres?.land || '',
    losDatum: convertDatum(parsed.los_datum),
    losBijzonderheden: parsed.bijzonderheden?.lossen || parsed.bijzonderheden_lossen || '',
    goederen: mappedGoederen,
    serviceADR: parsed.adr?.isADR || false,
    sourceType: sourceType,
    sourcePhone: parsed.sourcePhone || ''
  };
};

export const getButtonStyleFromSettings = (buttonKey, dashboardSettings, dotVerlopenCount = 0, trackingOverdueCount = 0) => {
  if (buttonKey === 'vervoerders' && dotVerlopenCount > 0) {
    return {
      backgroundColor: '#dc2626',
      color: '#ffffff',
      boxShadow: '0 8px 20px rgba(220,38,38,0.4), inset 0 1px 0 rgba(255,255,255,0.2)'
    };
  }

  if (buttonKey === 'palletTracking' && trackingOverdueCount > 0) {
    return {
      backgroundColor: '#dc2626',
      color: '#ffffff',
      boxShadow: '0 8px 20px rgba(220,38,38,0.4), inset 0 1px 0 rgba(255,255,255,0.2)'
    };
  }
  
  const bgColor = dashboardSettings?.buttonColors?.[buttonKey] || '#10b981';
  const textColor = dashboardSettings?.buttonTextColors?.[buttonKey] || '#ffffff';
  return {
    backgroundColor: bgColor,
    color: textColor,
    boxShadow: '0 8px 20px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2)'
  };
};
